export default __webpack_public_path__ + "static/21-e20503fb127053eda28342b2b9388a58.png";